import { fetcher } from "../fetcher"
import { useQueryClient } from "@tanstack/react-query"

type TransactionsPaymentRequestAttachmentApiResponse = {
  fileName: string
  fileContent: string
  responseBlob: Blob
}

type Params = {
  paymentRequestId: string
  attachmentId: string
  omitBase64?: boolean
}

const blobToBase64 = (blob: Blob) => {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise<string>((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result as string)
    }
  })
}

export function useTransactionPaymentRequestAttachment() {
  const queryClient = useQueryClient()

  return {
    fetchPaymentRequest: ({ paymentRequestId, attachmentId, omitBase64 }: Params) =>
      queryClient.fetchQuery<TransactionsPaymentRequestAttachmentApiResponse>({
        queryKey: [`/Attachment/PaymentRequest/${paymentRequestId}/File/${attachmentId}`],
        queryFn: async () => {
          const response = await fetcher(
            `/Attachment/PaymentRequest/${paymentRequestId}/File/${attachmentId}`,
            {
              method: "GET",
            },
            {
              useAccessToken: true,
            }
          )
          const responseBlob = await response.blob()
          let fileContent = ""
          if (!omitBase64) {
            fileContent = (await blobToBase64(responseBlob)).split(",")[1]
          }
          return {
            fileContent,
            responseBlob,
            fileName: attachmentId,
          }
        },
      }),
  }
}
